

































































































import DateMixin from "@/mixins/DateMixin";
import AccountIdValdationMixin from "@/mixins/AccountIdValdationMixin";
import { DalModule } from "@/store/dal.module";
import { Component, Mixins } from "vue-property-decorator";
import MonthPicker from "@/components/ui/MonthPicker.vue";
import moment from "moment";
import { translate } from "@/utils";
import { PaysInfo } from "~/dal/pays.info";

@Component({
  components: { MonthPicker },
  watch: {
    "period.from": "loadData",
    "period.to": "loadData",
    expanded: "expandedLoad",
  },
})
export default class PayInfoView extends Mixins(
  DateMixin,
  AccountIdValdationMixin,
) {
  expanded: PaysInfo[] = [];
  period = {
    from: "",
    to: "",
    min: "",
    max: "",
  };
  canLoad: boolean = false;

  translate(val: any) {
    return translate(val);
  }

  async expandedLoad() {
    this.expanded.forEach(async (el: PaysInfo) => {
      if (el && el.details && el.details.length == 0 && !el.detailsLoading) {
        try {
          el.detailsLoading = true;
          el.details = await DalModule.getReceiptDetails({
            Account_id: DalModule.AccountId,
            Month: el.MONTH_PAY,
            Year: el.YEAR_PAY,
            receipt: el.RECIEPT_NUMBER,
          });
        } finally {
          el.detailsLoading = false;
        }
      }
    });
  }

  get paysListLoading() {
    return DalModule.paysListLoading;
  }

  get paysInfoList() {
    return DalModule.paysInfoList;
  }

  get paysInfoLength() {
    return DalModule.paysInfoLength;
  }

  get headers() {
    return [
      {
        text: this.$t("pays.date"),
        value: "date",
        sortable: false,
      },
      {
        text: this.$t("pays.sum-pay"),
        value: "SUM_TOTAL",
        align: "right",
      },
      {
        text: this.$t("pays.bank"),
        value: "BANK_NAME",
        align: "right",
      },
      { text: "", value: "data-table-expand" },
    ];
  }

  async mounted() {
    DalModule.setPaysInfoList();
    const today = new Date();
    this.period.to = moment(today).format("YYYY-MM");
    this.period.from = moment(today).add(-3, "M").format("YYYY-MM");
    this.period.min = moment(today).add(-35, "M").format("YYYY-MM");
    this.period.max = moment(today).format("YYYY-MM");
    await this.validateAccountId();
    if (!this.$route.params.id) {
      this.$router.push({ name: "account-list" });
      return;
    }
    const acc = Number.parseInt(this.$route.params.id);
    if (acc) {
      DalModule.setAccountId(acc);
    }
    this.canLoad = true;
    await this.loadData();
  }

  async loadData() {
    try {
      DalModule.setPaysListLoading(true);
      DalModule.setPaysInfoList();
      if (this.canLoad)
        await DalModule.getReceiptInfo({
          Account_id: DalModule.AccountId,
          MonthFrom: moment(this.period.from).month() + 1,
          YearFrom: moment(this.period.from).year(),
          MonthTo: moment(this.period.to).month() + 1,
          YearTo: moment(this.period.to).year(),
        });
    } finally {
      //
    }
  }
}
